import { addError, removeError } from '@core/utils/error-functions';
import moment from 'moment';
var DataRangeValidation = /** @class */ (function () {
    function DataRangeValidation() {
    }
    DataRangeValidation.validate = function (formGroup) {
        var initialDate = formGroup.controls.from.value;
        var finalDate = formGroup.controls.until.value;
        var datesExist = Boolean(initialDate && finalDate);
        var isValidDates = moment(initialDate).isValid() && moment(finalDate).isValid();
        if (datesExist && isValidDates) {
            if (moment(initialDate).isSameOrAfter(finalDate)) {
                addError(formGroup.controls.from, 'dateRangeInvalid');
            }
            else {
                removeError(formGroup.controls.from, 'dateRangeInvalid');
            }
        }
        return null;
    };
    return DataRangeValidation;
}());
export { DataRangeValidation };
